import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteAdProduct } from "./deleteAdProduct.request";

const useDeleteAdProduct = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteAdProduct,
    ...options
  });
};

export default useDeleteAdProduct;
